import { boot } from 'quasar/wrappers';
import scrollto from 'vue-scrollto';

export default boot(({ app }) => {
  app.use(scrollto);
});
